import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-2 flex flex-column gap-2" }
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueInputText = _resolveComponent("PrimeVueInputText")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldErrors = _resolveComponent("FieldErrors")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.inline && _ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          })
        ], 64))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), {
          key: 2,
          class: _normalizeClass({ 'py-2': _ctx.inline }),
          "model-value": _ctx.modelValue,
          loading: _ctx.inline ? undefined : _ctx.loading,
          disabled: _ctx.disabled,
          options: _ctx.sortedOptions,
          "option-value": "id",
          "option-label": "name",
          "data-key": "id",
          filter: "",
          "filter-placeholder": _ctx.$t('search'),
          "empty-message": _ctx.$t('no_folders'),
          "empty-filter-message": _ctx.$t('no_folders'),
          "list-style": "max-height: 250px",
          multiple: _ctx.inline ? _ctx.multiple : undefined,
          display: _ctx.inline ? undefined : 'chip',
          "show-clear": _ctx.inline ? undefined : _ctx.showClear,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, _createSlots({ _: 2 }, [
          (_ctx.allowCreate)
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_PrimeVueInputText, {
                        modelValue: _ctx.newFolderName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newFolderName) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _ctx.$t('new_folder'),
                        disabled: _ctx.creating,
                        onKeyup: _withKeys(_ctx.createFolder, ["enter"])
                      }, null, 8, ["modelValue", "placeholder", "disabled", "onKeyup"]),
                      _createVNode(_component_PrimeVueButton, {
                        icon: "pi pi-plus",
                        loading: _ctx.creating,
                        disabled: !_ctx.newFolderName,
                        onClick: _ctx.createFolder
                      }, null, 8, ["loading", "disabled", "onClick"])
                    ]),
                    (_ctx.createError)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.createError), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["class", "model-value", "loading", "disabled", "options", "filter-placeholder", "empty-message", "empty-filter-message", "multiple", "display", "show-clear"])),
    (_ctx.name)
      ? (_openBlock(), _createBlock(_component_FieldErrors, {
          key: 3,
          "errors-map": _ctx.errorsMap,
          name: _ctx.name
        }, null, 8, ["errors-map", "name"]))
      : _createCommentVNode("", true)
  ]))
}